import React from 'react';
import { useCalendar } from '../../hooks/useCalendar';
import { useUnavailableDates } from '../../hooks/useUnavailableDates';
import CalendarModal from './CalendarModal';
import CalendarLegend from './CalendarLegend';

const unavailableDatesEnabled = window.wwoofBooking?.unavailableDatesEnabled || false;
const wwooferInitiatedEnabled = window.wwoofBooking?.settings?.wwooferInitiatedEnabled || false;

const CalendarView = ({ 
  bookings, 
  calendarModal, 
  setCalendarModal,
  calendarView,
  actionLoading,
  onEditDates,
  onCancel,
  onAccept,
  currentUserId,
  selectedStatuses,
  onStatusChange
}) => {
  // Unavailable dates are shown read-only here; editing happens via the
  // [user_availability_calendar] shortcode.
  const { unavailableDates } = useUnavailableDates(unavailableDatesEnabled ? currentUserId : null);

  const calendarRef = useCalendar(
    bookings,
    (bookingId) => {
      const booking = bookings.find(b => b.id == bookingId);
      if (booking) {
        setCalendarModal({ booking });
      }
    },
    calendarView,
    unavailableDates
  );

  // Close modal if the booking no longer exists after data refresh
  React.useEffect(() => {
    if (calendarModal && !bookings.find(b => b.id == calendarModal.booking.id)) {
      setCalendarModal(null);
    }
  }, [bookings, calendarModal]);

  // Update modal booking data when bookings array changes
  React.useEffect(() => {
    if (calendarModal) {
      const updatedBooking = bookings.find(b => b.id == calendarModal.booking.id);
      if (updatedBooking) {
        // Compare booking objects by status and other key properties to avoid unnecessary updates
        const hasStatusChanged = updatedBooking.status !== calendarModal.booking.status;
        const hasStartDateChanged = updatedBooking.start_date !== calendarModal.booking.start_date;
        const hasEndDateChanged = updatedBooking.end_date !== calendarModal.booking.end_date;
        
        if (hasStatusChanged || hasStartDateChanged || hasEndDateChanged) {
          setCalendarModal({ booking: updatedBooking });
        }
      }
    }
  }, [bookings, calendarModal]);

  return (
    <div className='calendar-view'>
      <div ref={calendarRef} />
      <CalendarLegend
        unavailableDatesEnabled={unavailableDatesEnabled}
        wwooferInitiatedEnabled={wwooferInitiatedEnabled}
        selectedStatuses={selectedStatuses}
        onStatusChange={onStatusChange}
      />
      {calendarModal && (
        <CalendarModal
          booking={calendarModal.booking}
          onClose={() => setCalendarModal(null)}
          actionLoading={actionLoading}
          onEditDates={onEditDates}
          onCancel={onCancel}
          onAccept={onAccept}
          currentUserId={currentUserId}
        />
      )}
    </div>
  );
};

export default CalendarView;
